import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { articles } from '@/mocks/articles';

const articleImages: Record<string, string> = {
  'article-ssis-001': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20editorial%20composition%20with%20warm%20cream%20and%20terracotta%20tones%2C%20soft%20geometric%20shapes%2C%20clean%20negative%20space%2C%20elegant%20gradient%2C%20modern%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text%2C%20high%20quality&width=800&height=480&seq=article-ssis-001&orientation=landscape',
  'article-midv-001': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20editorial%20composition%20with%20warm%20cream%20and%20soft%20peach%20tones%2C%20smooth%20geometric%20layers%2C%20clean%20negative%20space%2C%20elegant%20gradient%2C%20modern%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text%2C%20high%20quality&width=800&height=480&seq=article-midv-001&orientation=landscape',
  'article-top20': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20editorial%20composition%20with%20warm%20beige%20and%20coral%20tones%2C%20layered%20circular%20shapes%2C%20clean%20negative%20space%2C%20elegant%20gradient%2C%20modern%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text%2C%20high%20quality&width=800&height=480&seq=article-top20&orientation=landscape',
  'article-ipx': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20editorial%20composition%20with%20warm%20cream%20and%20sand%20tones%2C%20elegant%20flowing%20lines%2C%20clean%20negative%20space%2C%20soft%20gradient%2C%20modern%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text%2C%20high%20quality&width=800&height=480&seq=article-ipx&orientation=landscape',
  'article-search-tips': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20editorial%20composition%20with%20warm%20terracotta%20and%20ivory%20tones%2C%20angular%20geometric%20patterns%2C%20clean%20negative%20space%2C%20elegant%20gradient%2C%20modern%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text%2C%20high%20quality&width=800&height=480&seq=article-search-tips&orientation=landscape',
  'article-summer-new': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20editorial%20composition%20with%20warm%20peach%20and%20cream%20tones%2C%20organic%20curved%20shapes%2C%20clean%20negative%20space%2C%20elegant%20gradient%2C%20modern%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text%2C%20high%20quality&width=800&height=480&seq=article-summer-new&orientation=landscape',
  'article-4k': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20editorial%20composition%20with%20warm%20coral%20and%20beige%20tones%2C%20sharp%20geometric%20diamonds%2C%20clean%20negative%20space%2C%20elegant%20gradient%2C%20modern%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text%2C%20high%20quality&width=800&height=480&seq=article-4k&orientation=landscape',
  'article-collection': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20editorial%20composition%20with%20warm%20sand%20and%20terracotta%20tones%2C%20grid%20based%20shapes%2C%20clean%20negative%20space%2C%20elegant%20gradient%2C%20modern%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text%2C%20high%20quality&width=800&height=480&seq=article-collection&orientation=landscape',
  'article-abw': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20editorial%20composition%20with%20warm%20ivory%20and%20peach%20tones%2C%20concentric%20geometric%20rings%2C%20clean%20negative%20space%2C%20elegant%20gradient%2C%20modern%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text%2C%20high%20quality&width=800&height=480&seq=article-abw&orientation=landscape',
  'article-stars': 'https://readdy.ai/api/search-image?query=Minimalist%20abstract%20editorial%20composition%20with%20warm%20cream%20and%20coral%20tones%2C%20starburst%20geometric%20shapes%2C%20clean%20negative%20space%2C%20elegant%20gradient%2C%20modern%20magazine%20style%2C%20warm%20atmosphere%2C%20no%20text%2C%20high%20quality&width=800&height=480&seq=article-stars&orientation=landscape',
};

export default function ArticleList() {
  const { t } = useTranslation();

  const latestArticles = articles.slice(0, 6);

  return (
    <section className="w-full py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-end justify-between mb-12">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
                {t('home:sectionLatest')}
              </h2>
              <p className="text-sm text-foreground-500">
                {t('home:sectionLatestDesc')}
              </p>
            </div>
            <Link
              to="/category/quanxin"
              className="hidden sm:flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
            >
              {t('btnViewAll')}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
            {latestArticles.map((article) => (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={articleImages[article.imageSeq]}
                    alt={article.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                  <div className="absolute top-3 left-3">
                    <span className="text-xs bg-primary-500 text-background-50 px-2.5 py-1 rounded-full whitespace-nowrap">
                      {article.categoryName}
                    </span>
                  </div>
                </div>
                <div className="p-5">
                  <h3 className="text-base font-semibold text-foreground-900 mb-2 line-clamp-2 group-hover:text-primary-600 transition-colors leading-snug">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-500 line-clamp-2 mb-4 leading-relaxed">
                    {article.excerpt}
                  </p>
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-3 text-xs text-foreground-400">
                      <span className="flex items-center gap-1">
                        <div className="w-3.5 h-3.5 flex items-center justify-center">
                          <i className="ri-calendar-line text-xs"></i>
                        </div>
                        {article.date}
                      </span>
                      <span className="flex items-center gap-1">
                        <div className="w-3.5 h-3.5 flex items-center justify-center">
                          <i className="ri-eye-line text-xs"></i>
                        </div>
                        {article.views.toLocaleString()}
                      </span>
                    </div>
                    <span className="text-xs text-foreground-400">{article.readTime}</span>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          <div className="mt-8 text-center sm:hidden">
            <Link
              to="/category/quanxin"
              className="inline-flex items-center gap-1.5 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors"
            >
              {t('btnViewAll')}
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-sm"></i>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}